

function match(str, pattern) {
    var regmatch = str.match(pattern);
    if (regmatch) {
        return regmatch[1];
    }
}

define(['squid/index', 'components/xo-beaver/dist/logger', 'components/xo-device-info/dist/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-return-to-merchant', ['squid', 'xo-device-info']).factory('$ReturnToMerchant', function ($window, $DeviceInfo, $rootScope, $util, $feature, $logger, $state, $timeout, $CheckoutSessionModel, $CheckoutCartModel) {
        return {
            goTo: function goTo(url, forceRedirect) {

                $logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
                    url: url
                });

                // if V4 in-context integration, we'll terminate and call the close handler.
                if (window.xchild) {
                    $logger.done();
                    $rootScope.$emit('loading');

                    var params = {
                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/),
                        intent: $CheckoutCartModel.instance($rootScope.token).payment_action
                    };

                    if (window.xprops.onCancel) {
                        params.cancelUrl = url;
                        return window.xprops.onCancel(params);
                    }

                    return window.xchild.close();
                }

                var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
                var showPaymentSuccess = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);

                if (showPaymentSuccess) {
                    $logger.info('redirect', {
                        url: url
                    });
                    $window.onunload = $window.onbeforeunload = function () {};
                    $window.location = url;
                    return $state.go('checkout.genericMessage', {
                        code: 'PAYMENT_SUCCESS'
                    });
                }

                if (forceRedirect) {
                    $util.redirect(url);
                }

                var isVZeroIframe = Boolean($rootScope.partnerIntegration) && $util.isIFrame();

                if (isVZeroIframe) {
                    $util.redirect(url, { redirectImmediateParent: true });
                }

                // If we are not in minibrowser, do a hard redirect
                else if ($rootScope.partnerIntegration || !$rootScope.miniBrowser && !$util.isIFrame()) {
                        $util.redirect(url);
                    } else {

                        // Construct a message to send to the parent
                        var result = this.postToMerchant({
                            operation: 'return_to_merchant',
                            returnUrl: url,
                            updateParent: true
                        });

                        // Otherwise we have no choice but to return to the merchant
                        if (!result) {
                            $util.redirect(url);
                        }
                    }

                var userStatus = function userStatus() {
                    $logger.info('redirected_user_still_on_page_second_checkpoint');
                };

                $timeout(function () {
                    $logger.info('redirected_user_still_on_page_first_checkpoint');
                    $timeout(userStatus, 10000);
                }, 10000);
            },

            postToMerchant: function postToMerchant(msg) {

                try {
                    msg = angular.toJson(msg, 0);

                    // If we are not in IE, attempt to send a postMessage
                    if ($window.opener && ($window.navigator.userAgent.match(/edge/i) || $window.opener.postMessage && !$window.navigator.userAgent.match(/msie|trident/i))) {
                        $window.opener.postMessage(msg, '*');
                        $logger.info('minibrowser_postmessage');
                        return true;
                    }
                    // Otherwise, attempt to send a message through the iframe bridge
                    var bridge = $window.opener && $window.opener.frames && $window.opener.frames.length && $window.opener.frames.PayPalBridge;

                    if (bridge && bridge.returnToParent) {
                        bridge.returnToParent(msg);
                        $logger.info('minibrowser_bridgemessage');
                        return true;
                    }

                    $logger.warn('minibrowser_nopostback');
                } catch (err) {
                    $logger.error('minibrowser_postback_error', {
                        error: err.stack || err.toString()
                    });
                }

                return false;
            },

            postTo: function postTo(url, msg) {
                var form = document.createElement('form');
                form.method = 'POST';
                form.action = url;
                form.className = 'hide';

                for (var key in msg) {
                    var input = document.createElement('input');
                    input.name = key;
                    input.value = msg[key];
                    form.appendChild(input);
                }

                $window.document.body.appendChild(form);
                form.submit();
                $logger.info('web_postmessage');
                return true;
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-return-to-merchant/dist/util.js
// module id = ./components/xo-return-to-merchant/dist/util.js
// module chunks = 1